import React from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { Form, Button, Card, Spinner, Alert } from 'react-bootstrap';
import espergo from '../../../assets/esp-ergo.jpeg';
import styles from '../../../styles.module.css';
import { getPrefix } from '../../../util/utils';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';
import selectErgoById from '../../../services/ergo';

export default function EspelhoErgo() {
  const { id } = useParams();
  const { data: ergo, error, isLoading } = useSWR(
    id ? ['ergo', id] : null,
    () => selectErgoById(id)
  );

  if (error) {
    return (
      <Alert variant="danger" style={{ marginTop: 10 }}>
        <Alert.Heading>Erro ao carregar laudo de ergo!</Alert.Heading>
        <p>Tente novamente.</p>
      </Alert>
    );
  }

  if (isLoading || !ergo) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
        }}
      >
        <Spinner animation="border" variant="dark" size="lg" />
      </div>
    );
  }

  return (
    <Card>
      <LaudoCardHeader title="LAUDO DE TESTE ERGOMÉTRICO" />

      <Card.Body>
        <Form noValidate className={styles.contentReport}>
          <strong className="mr-auto">Cod Ergo: </strong>
          {ergo?.CODEXAME}&nbsp;&nbsp;&nbsp;
          <strong className="mr-auto">Nome do Paciente: </strong>
          {`${ergo?.CODPAC} - ${ergo?.NOMEPAC}`}
          <br></br>
          <strong className="mr-auto">Data de Nasc: </strong>
          {`${ergo?.dataNasc}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong className="mr-auto">Sexo: </strong>
          {`${ergo?.SEXOPAC}`}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong className="mr-auto">Idade: </strong>
          {`${ergo?.idadePAC} anos`}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong className="mr-auto">Data do Exame: </strong>
          {ergo?.dataErgo}
          <br></br>
          <strong className="mr-auto">Convênio: </strong>
          {ergo?.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong className="mr-auto">Peso: </strong>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong className="mr-auto">Altura: </strong>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong className="mr-auto">Fone: </strong>
          {ergo?.CELULARPAC}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <br></br>
          <strong className="mr-auto">
            Médico que Realizou: {getPrefix(ergo?.CODREALIZOU)}{' '}
          </strong>
          {`${ergo?.Realizou}`}
          <br></br>
          <strong className="mr-auto">
            Médico que Solicitou: {getPrefix(ergo?.CODSOLICITANTE)}{' '}
          </strong>
          {`${ergo?.Solicitou}`}
          <div className={styles.imageReport}>
            <img
              src={espergo}
              alt="espelho ergo"
              loading="lazy"
              style={{
                width: '100%',
                height: '32cm',
                objectFit: 'fill',
                display: 'block',
                margin: '0 auto',
              }}
            />
          </div>
          <div id="removeMe" className="text-right">
            <Button variant="outline-primary" onClick={() => window.print()}>
              Imprimir
            </Button>{' '}
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}
